
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/announcement",
      function () {
        return require("private-next-pages/investor/announcement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/announcement"])
      });
    }
  